import {
  OBSERVADOR_INICIALITZAR,
  OBTENIR_OBSERVADORS,
  OBTENIR_OBSERVADORS_LLISTAT,
  OBTENIR_DADES_OBSERVADOR
} from "../../actions/actionTypes";

const ESTAT_INICIAL = false;

const peticioEnCurs = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case OBSERVADOR_INICIALITZAR:
      return ESTAT_INICIAL;

    case `${OBTENIR_OBSERVADORS}_EN_CURS`:
    case `${OBTENIR_OBSERVADORS_LLISTAT}_EN_CURS`:
    case `${OBTENIR_DADES_OBSERVADOR}_EN_CURS`:
      return true;

    case `${OBTENIR_OBSERVADORS}_SUCCESS`:
    case `${OBTENIR_OBSERVADORS}_ERROR`:
    case `${OBTENIR_OBSERVADORS_LLISTAT}_SUCCESS`:
    case `${OBTENIR_OBSERVADORS_LLISTAT}_ERROR`:
    case `${OBTENIR_DADES_OBSERVADOR}_SUCCESS`:
    case `${OBTENIR_DADES_OBSERVADOR}_ERROR`:
      return false;

    default:
      return state;
  }
};

export default peticioEnCurs;

export const getPeticioEnCurs = state => state;
export const getPeticioError = state => state.error;
